<template>
    <div class="button-wrapper" @click="$emit('click')">
        <div :class="['button', { 'is-uppercase': !lowercase, 'is-small': small }]">
            <BaseIcon name="chevron down"
                      viewBox="0 0 27 20"
                      color="var(--lightGrey-25)"
                      :class="['icon', { 'rotate-icon': isExpanded }]">
                <ChevronDown />
            </BaseIcon>
        </div>
    </div>
</template>

<script>
    import { BaseIcon, ChevronDown } from './icons';

    export default {
        name: "ChevronDownButton",
        components: {
            ChevronDown,
            BaseIcon,
        },
        props: {
            lowercase: {
                type: Boolean,
                required: false,
                default: false,
            },
            small: {
                type: Boolean,
                required: false,
                default: false,
            },
            isExpanded: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
    };
</script>


<style lang="scss" scoped>
    .button-wrapper {
        .button {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 0.5rem;
            padding: 15px 10px;
            cursor: pointer;
            font-size: 1.00rem;
            font-weight: 700;
            transition: all 0.3s linear;
            background-color: transparent;
            color: var(--text-body-75);

            &.is-small {
                font-size: 1.15rem;
                padding: 15px !important;
            }

            &.is-uppercase {
                text-transform: uppercase;
            }

            .icon {
                transition: transform 0.2s ease-in-out;
            }

            .rotate-icon {
                transform: rotate(0.5turn);
            }

            svg {
                width: 1.7rem;
                height: 1.7rem;
                min-width: 1.7rem;
            }
        }

        .dropdown {
            margin-top: 0.5rem;
            margin-right: auto;
            margin-left: auto;
            position: absolute;
            z-index: 1;
            min-width: fit-content;
            width: 7rem;
            left: 0;
            right: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 0.25rem;
            padding: 0.5rem 0;
            background-color: var(--form-background);
            color: var(--primary);
            font-size: 1.2rem;
            font-weight: 700;

            &.is-small {
                font-size: 1.2rem;
            }

            &.is-uppercase {
                text-transform: uppercase;
            }

            .dropdownOption {
                cursor: pointer;
                padding: 0.5rem 2rem;
            }
        }
    }
</style>
